import Typography from 'components/Typography';
import { usePTPConfigContext } from 'GlobalConfig.context';
import { useLocale } from '@pperform/pp-react-components/PpLocaleProvider';
import { useTranslation } from 'react-i18next';
import { ReturnShipment } from '../../../../models/ReturnShipment.model';
import { Description } from './LastEvent.styles';
import {
  getEventDisplayName,
  getEventDisplayTime,
} from '../../../../../../services/ReturnShipment.service';

interface LastEventProps {
  shipment: ReturnShipment;
}

export const LastEvent = (props: LastEventProps): JSX.Element | null => {
  const { shipment } = props;
  const { locale } = useLocale();
  const { timezone, parcelDetailsBox } = usePTPConfigContext();
  const { t } = useTranslation();
  const lastEvent = shipment.latestMixedEvent;

  if (!lastEvent) {
    return null;
  }

  const displayTime = getEventDisplayTime(lastEvent, {
    timezone,
    locale,
    displayFormat: parcelDetailsBox.lastEventDateFormat,
  });

  const displayName = getEventDisplayName(lastEvent, t);

  return (
    <div>
      <Description>{displayTime}</Description>
      <Typography level="displayMd">{displayName}</Typography>
    </div>
  );
};
